import { normalize } from 'normalizr';

import { mapListToRecords, normalizeList } from '@sophocles/entities/entityUtils';
import { SolarSiteOption, solarSiteOptionSchema } from '@sophocles/entities/SolarSiteOption/solarSiteOptionRecord';
import { addToast } from '@sophocles/features/toast';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';

/* Receive Actions */
export const RECEIVE_SOLAR_SITE_OPTIONS = 'RECEIVE_SOLAR_SITE_OPTIONS';
function receiveSolarSiteOptions(json) {
  return {
    type: RECEIVE_SOLAR_SITE_OPTIONS,
    solarSiteOptions: mapListToRecords(json, SolarSiteOption),
  };
}

/* Request Actions */
// starter request
export const REQUEST_SOLAR_SITE_OPTION = 'REQUEST_SOLAR_SITE_OPTION';
function requestSolarSiteOption(solarSiteOption_id) {
  return {
    type: REQUEST_SOLAR_SITE_OPTION,
    solarSiteOption_id,
  };
}

export const REQUEST_SOLAR_SITE_OPTION_FOR_SITE = 'REQUEST_SOLAR_SITE_OPTION_FOR_SITE';
function requestSolarSiteOptionForSite(site_id) {
  return {
    type: REQUEST_SOLAR_SITE_OPTION_FOR_SITE,
    site_id,
  };
}

/* Fetch Actions */
// starter fetch

export function fetchSolarSiteOption(solarSiteOption_id) {
  return dispatch => {
    dispatch(requestSolarSiteOption(solarSiteOption_id));
    return apiClient
      .get(`/solarsiteoptions/${solarSiteOption_id}/`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data, 'solarSiteOptions', solarSiteOptionSchema))
      .then(json => dispatch(receiveSolarSiteOptions(json.entities.solarSiteOptions)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_SOLAR_SITE_OPTION)));
  };
}

export function fetchSolarSiteOptionForSite(site_id) {
  return dispatch => {
    dispatch(requestSolarSiteOptionForSite(site_id));
    return apiClient
      .get(`/solarsiteoptions/?site=${site_id}`)
      .then(checkHttpStatus)
      .then(response => normalizeList(response.data.results, 'solarSiteOptions', solarSiteOptionSchema))
      .then(json => dispatch(receiveSolarSiteOptions(json.entities.solarSiteOptions)))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_SOLAR_SITE_OPTION_FOR_SITE)));
  };
}

/* Edit Actions */
export const EDIT_SOLAR_SITE_OPTION = 'EDIT_SOLAR_SITE_OPTION';
export function editSolarSiteOption(solarSiteOption_id) {
  return {
    type: EDIT_SOLAR_SITE_OPTION,
    solarSiteOption: solarSiteOption_id,
  };
}

export function patchSolarSiteOption(solarSiteOption_id, values) {
  return dispatch => {
    dispatch(editSolarSiteOption(solarSiteOption_id));
    return apiClient
      .patch(`/solarsiteoptions/${solarSiteOption_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, solarSiteOptionSchema))
      .then(json => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'Solar Options updated successfully',
            level: 'success',
            dismissible: true,
          }),
        );
        return dispatch(receiveSolarSiteOptions(json.entities.solarSiteOptions));
      })
      .catch(error => {
        dispatch(
          addToast({
            title: 'Error',
            message: 'An error has occurred, options were not saved.',
            level: 'error',
            dismissible: true,
          }),
        );
        return dispatch(genericErrorAction(error, EDIT_SOLAR_SITE_OPTION));
      });
  };
}

/* Create Actions */
export const CREATE_SOLAR_SITE_OPTION = 'CREATE_SOLAR_SITE_OPTION';
function sayCreateSolarSiteOption(values) {
  return {
    type: CREATE_SOLAR_SITE_OPTION,
    values: values,
  };
}

export function createSolarSiteOption(values) {
  return dispatch => {
    dispatch(sayCreateSolarSiteOption(values));
    return apiClient
      .post(`/solarsiteoptions/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, solarSiteOptionSchema))
      .then(json => {
        dispatch(
          addToast({
            title: 'Success',
            message: 'Solar Options created successfully',
            level: 'success',
            dismissible: true,
          }),
        );
        return dispatch(receiveSolarSiteOptions(json.entities.solarSiteOptions));
      })
      .catch(error => {
        dispatch(
          addToast({
            title: 'Error',
            message: 'An error has occurred, options were not saved.',
            level: 'error',
            dismissible: true,
          }),
        );
        return dispatch(genericErrorAction(error, CREATE_SOLAR_SITE_OPTION));
      });
  };
}

/* Delete Actions */
export const DELETE_SOLAR_SITE_OPTION = 'DELETE_SOLAR_SITE_OPTION';
function sayDeleteSolarSiteOption(solarSiteOption_id) {
  return {
    type: DELETE_SOLAR_SITE_OPTION,
    solarSiteOption: solarSiteOption_id,
  };
}

export function deleteSolarSiteOption(solarSiteOption_id) {
  return dispatch =>
    apiClient
      .delete(`/solarsiteoptions/${solarSiteOption_id}/`)
      .then(checkHttpStatus)
      .then(r => dispatch(sayDeleteSolarSiteOption(solarSiteOption_id)))
      .catch(error => dispatch(genericErrorAction(error, DELETE_SOLAR_SITE_OPTION)));
}
